import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import SelectableContainer from '../../../../UI/SelectableContainer/SelectableContainer';
import {getDeliveryOptions} from '../../../actions/deliveryOptionActions';
import {updateSelectedCollectionPoint} from '../../../actions/pudo-actions';
import {getPudo, getSelectedPudoAddress} from '../../../selectors/PudoSelectors';
import {getSettings} from '../../../selectors/selectors';
import CollectionSavedAddress from './CollectionSavedAddress';
import './CollectionSavedAddresses.scss';

export class CollectionSavedAddresses extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.deliveryType !== 'pudo') return;
    
    const hasChangedCollectionAddress = prevProps.selectedCollectionPointAddress !== this.props.selectedCollectionPointAddress;
    
    const newCollectionDeliveryCallExceptions = this.props.shouldUseNewCollectionOverlay
      && this.props.selectedCollectionPointAddress?.name;
    
    if (hasChangedCollectionAddress && (!newCollectionDeliveryCallExceptions || !prevProps.selectedCollectionPointAddress)) {
      this.props.getDeliveryOptions();
    }
  }
  
  render() {
    return (
      <div className="CollectionSavedAddresses">
        {this.props.addresses.map((address, index) => (
          <div className="CollectionSavedAddresses__address">
            {!this.props.shouldUseNewCollectionOverlay && (
              <SelectableContainer
                componentId={`StoredCollectionAddress-${index}`}
                isSelected={index === this.props.selectedCollectionPoint}
              >
                <CollectionSavedAddress
                  radioInputHidden
                  disabled={this.props.disabled}
                  checked={this.props.selectedCollectionPoint === index}
                  index={index}
                  key={index}
                  address={address}
                  lastIndex={this.props.addresses.length}
                  updateSelectedCollectionPoint={this.props.updateSelectedCollectionPoint}
                />
              </SelectableContainer>
            )}
          </div>
        ))}
        {this.props.shouldUseNewCollectionOverlay && (this.props.addresses.length >= 1) && (
          <div className="NewStoredCollectionAddress">
            <SelectableContainer
              componentId="StoredCollectionAddress"
              isSelected
            >
              <CollectionSavedAddress
                radioInputHidden
                disabled={this.props.disabled}
                checked
                key={this.props.addresses.length}
                address={this.props.addresses[this.props.addresses.length - 1]}
                updateSelectedCollectionPoint={this.props.updateSelectedCollectionPoint}
              />
            </SelectableContainer>
          </div>
        )}
      </div>
    );
  }
}

CollectionSavedAddresses.propTypes = {
  addresses: PropTypes.array.isRequired,
  selectedCollectionPoint: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  selectedCollectionPointAddress: PropTypes.object,
  deliveryType: PropTypes.string.isRequired,
  shouldUseNewCollectionOverlay: PropTypes.func,
  
  // Actions
  updateSelectedCollectionPoint: PropTypes.func.isRequired,
  getDeliveryOptions: PropTypes.func.isRequired,
  savedAddressExists: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  addresses: state.pudo.savedAddresses,
  selectedCollectionPoint: parseInt(state.pudo.selectedCollectionPoint),
  selectedCollectionPointAddress: getSelectedPudoAddress(state),
  deliveryType: state.delivery.deliveryType,
  shouldUseNewCollectionOverlay: !!getSettings(state)?.should_use_new_collection_overlay,
  savedAddressExists: getPudo(state).savedAddresses.length > 0,
});

export default connect(mapStateToProps, {updateSelectedCollectionPoint, getDeliveryOptions})(CollectionSavedAddresses);
